// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import { Table, TableBody, TableRow, TableHeader } from 'common/components/Tables';
import { Numeric, Currency } from 'common/components/Number';
import Estimation from 'common/modules/proposition/domain/estimation';

export function generateHeader(t: any) {
  return [
    <td key={1}>{t('nbOfOccasions')}</td>,
    <td key={2}>{t('totalCost')}</td>,
    <td key={3}>{t('costPerThousand')}</td>,
    <td key={4}>{t('impressions')}</td>,
  ];
}


export function generateRow(estimation: Estimation, t: any) {
  if (!estimation.summary) {
    return [<td key="not_calculated" rowSpan={4}>{t('notCalculated')}</td>];
  }

  const totalSummary = estimation.getTotalSummary();

  return [
    <td key={1}><Numeric value={totalSummary.numberOfOpportunities} /></td>,
    <td key={2}><Currency value={totalSummary.totalCost} /></td>,
    <td key={3}><Currency value={totalSummary.costPerThousand} /></td>,
    <td key={4}><Numeric value={totalSummary.impressions} /></td>,
  ];
}

type Props = {
  estimations: Estimation[],
  t: any
}

function SalesEstimationBriefSummary({ estimations, t }: Props) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          {generateHeader(t)}
        </TableRow>
      </TableHeader>
      <TableBody>
        {estimations.map((estimation: Estimation) => {
          return (
            <TableRow key={estimation.reference}>
              {generateRow(estimation, t)}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}

export default translate('sales')(SalesEstimationBriefSummary);



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/components/SalesEstimationBriefSummary.js